import axios from "../api/axios";

export const getEprescriptions = async (
  userId: number,
  token: string
) => {
  const response = await axios.get("prescriptions", {
    params: {
      user_id: userId,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data.data;
};